import React, { Component } from 'react';
import pick from 'lodash/pick';
import LessonService from '../../services/LessonService';
import LoadingSpinner from '../LoadingSpinner';
import Modal from '../Modal';
import './styles.css';

const ModalState = {
  NOT_SENT: 'NOT_SENT',
  SENDING: 'SENDING',
  ERROR: 'ERROR',
  SENT: 'SENT'
};

export default class LessonsMessageModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      phoneOrEmail: '',
      instrument: '',
      studentAge: '',
      extraInfo: '',
      modalState: ModalState.NOT_SENT
    };
    this._lessonService = new LessonService();
  }

  render() {
    return (
      <Modal className="lessons-message-modal" disableDismissal={this.state.modalState === ModalState.SENDING} {...this.props}>
        {this._renderContent()}
      </Modal>
    );
  }

  _handleNameChange = (event) => this.setState({ name: event.target.value });

  _handlePhoneOrEmailChange = (event) => this.setState({ phoneOrEmail: event.target.value });

  _handleInstrumentChange = (event) => this.setState({ instrument: event.target.value });

  _handleStudentAgeChange = (event) => this.setState({ studentAge: event.target.value });

  _handleExtraInfoChange = (event) => this.setState({ extraInfo: event.target.value });

  _handleSubmissionClick = async () => {

    this.setState({ modalState: ModalState.SENDING });
    try {
      const params = pick(this.state, [
        'name',
        'phoneOrEmail',
        'instrument',
        'studentAge',
        'extraInfo',
      ]);
      await this._lessonService.sendLessonInfoMessage(params);
      this.setState({ modalState: ModalState.SENT });
    } catch (error) {
      console.log(`An error occurred while sending the lesson info request: ${error.message}`); // eslint-disable-line no-console
      this.setState({ modalState: ModalState.ERROR });
    }
  }

  _renderContent() {

    switch (this.state.modalState) {
      case ModalState.NOT_SENT:
        return this._renderForm();
      case ModalState.SENDING:
        return (
          <div className="modal-content">
            <LoadingSpinner className="modal-spinner" message="Sending..."/>
          </div>
        );
      case ModalState.ERROR:
        return (
          <div className="modal-content modal-message">
            <h2>Yikes!</h2>
            <p>
              Sorry, but an error occurred while trying to send your message.
              Please call us at (765)474-2942 instead.
            </p>
            <div className="modal-buttons">
              <button onClick={this.props.onDismiss}>Ok</button>
            </div>
          </div>
        );
      case ModalState.SENT:
        return (
          <div className="modal-content modal-message">
            <h2>Thank you!</h2>
            <p>We'll get back to you soon.</p>
            <div className="modal-buttons">
              <button onClick={this.props.onDismiss}>Ok</button>
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  _renderForm() {

    const submissionDisabled = !(this.state.name.trim() && this.state.phoneOrEmail.trim());
    return (
      <div className="modal-content">
        <h2>Request lesson info</h2>
        <p>
          Let us know which times work best for you,
          and we'll respond with a list of available times!
        </p>
        <div className="lessons-message-form">
          <div>
            <div>Your name:</div>
            <input placeholder="name (required)" value={this.state.name} onChange={this._handleNameChange}/>
          </div>
          <div>
            <div>Phone or email:</div>
            <input placeholder="phone number or email (required)" value={this.state.phoneOrEmail} onChange={this._handlePhoneOrEmailChange}/>
          </div>
          <div>
            <div>Instrument</div>
            <select value={this.state.instrument} onChange={this._handleInstrumentChange}>
              <option value="">Choose...</option>
              <option value="guitar">guitar</option>
              <option value="bass guitar">bass guitar</option>
              <option value="drums">drums</option>
              <option value="ukelele">ukelele</option>
              <option value="banjo">banjo</option>
              <option value="audio recording">audio recording</option>
            </select>
          </div>
          <div>
            <div>Student age:</div>
            <input placeholder="student age" value={this.state.studentAge} onChange={this._handleStudentAgeChange}/>
          </div>
          <div>
            <div>Extra info or questions:</div>
            <textarea placeholder="extra info or questions" value={this.state.extraInfo} onChange={this._handleExtraInfoChange}></textarea>
          </div>
        </div>
        <div className="modal-buttons">
          <button onClick={this.props.onDismiss}>Cancel</button>
          <button className="submit-button" disabled={submissionDisabled} onClick={this._handleSubmissionClick}>Send</button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LessonsMessageModal/index.js